<template>
  <div class="container">
    <h2>Sorry, it doesn't seem to be anything here.</h2>
    <a href="/" class="btn btn-primary">Go back</a>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
</style>
